angular.module("ainapp")
    .controller("addLeadController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Add Lead";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            }, function (err) {
                toastr.error($scope.LanguageData.NetworkError);
            })

            $scope.LeadTypes = [];
            MainService.LeadTypeInDropdown().then(function (response) {
                $scope.LeadTypes = response.data;
            }, function (err) {
                toastr.error($scope.LanguageData.NetworkError);
            })

            $scope.LeadSources = [];
            MainService.LeadSourcesInDropdown().then(function (response) {
                $scope.LeadSources = response.data;
            }, function (err) {
                toastr.error($scope.LanguageData.NetworkError);
            })

            $scope.Cities = [];
            MainService.CitiesInDropdown().then(function (response) {
                $scope.Cities = response.data;
            }, function (err) {
                toastr.error($scope.LanguageData.NetworkError);
            })


            //            $scope.FollowupTypes = [];
            //            MainService.FollowupTypesInDropdown().then(function (response) {
            //                $scope.FollowupTypes = response.data;
            //            }, function (err) {
            //                toastr.error("Network Error");
            //            })

            $scope.VDesign = {};
            MainService.VoucherDesignsbyType("Lead").then(function (response) {
                $scope.VDesign = response.data;
            });

            $scope.Init = function () {
                $scope.TokenInfo = AuthenticationService.getTokenInfo();

                $scope.ViewVal = 0;

                $scope.Lead = {
                    Date: new Date(),
                    EmployeeId: $scope.TokenInfo.EmployeeId,
                    CustomerCityId: "",
                    CustomerName: "",
                    CustomerMobileNo1: "",
                    CustomerMobileNo2: "",
                    CustomerEmail: "",
                    CustomerAddress: "",
                    Probability: 50,
                    Description: "",
                    LeadTypeId: "",
                    LeadSourceId: "",

                    PlannedMeetingDate: "",
                    IsFolloup: true,
                    FollowupTypeId: "",
                    FollowEmployeeId: "",
                    FollowRemarks: "",
                    FollowupStatusId: "",

                }


                $scope.load = 0;
                if ($stateParams.LeadId > 0) {
                    MainService.getLeadbyId($stateParams.LeadId).then(function (response) {
                        $scope.Lead = response.data;
                        $scope.Lead.Date = new Date(response.data.Date);
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                    })
                } else {
                    MainService.GetNextLeadNo().then(function (response) {
                        $scope.Lead.RefNo = response.data;
                    })
                }

            }
            $scope.Init();







            $scope.AddData = function () {
                if ($scope.Lead.Name == "") {
                    toastr.warning($scope.LanguageData.EntertheName);

                } else if ($scope.Lead.EmployeeId == "") {
                    toastr.warning($scope.LanguageData.SelectEmployee);

                } else if ($scope.Lead.LeadTypeId == "") {
                    toastr.warning($scope.LanguageData.SelectLeadType);

                } else if ($scope.Lead.LeadSourceId == "") {
                    toastr.warning($scope.LanguageData.SelectLeadSource);

                } else if ($scope.Lead.CustomerName == "") {
                    toastr.warning($scope.LanguageData.EnterCustomerName);
                } else if ($scope.Lead.CustomerMobileNo1 == "") {
                    toastr.warning($scope.LanguageData.EnterCustomerMobileNo);
                } else if ($scope.Lead.CustomerCityId == "") {
                    toastr.warning($scope.LanguageData.SelectCustomerCity);
                } else {
                    $scope.load = 1;
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    $scope.Lead.DateMonth = $scope.Lead.Date.getMonth() + 1;
                    $scope.Lead.DateDay = $scope.Lead.Date.getDate();
                    $scope.Lead.DateYear = $scope.Lead.Date.getFullYear();
                    MainService.AddLead($scope.Lead).then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $scope.Init();
                            $state.go('Lead');
                            $scope.load = 0;
                        } else {
                            toastr.error("Error");
                            $scope.load = 0;
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $scope.load = 0;
                        $.LoadingOverlay("hide");
                    });
                }
            }


            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                $scope.SelectedDataForDelete = data;
                $("#myModal2").modal("show");
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.DeleteLead($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#myModal2').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $scope.load = 0;
                    $.LoadingOverlay("hide");
                });
            }




                }])
